// src/pages/Appli/AppliAdmin/Prospects/components/ProspectsCards.jsx
import React, { useState } from "react";
import ButtonEdit from "../../../../../components/Button/ButtonEdit";
import ButtonDelete from "../../../../../components/Button/ButtonDelete";

export function ProspectsCards({
  data = [],
  onEdit,
  onDelete,
  renderStatut,           // on l’affiche dans la zone déroulée pour alléger l’entête
  forceAllBreakpoints = false,
}) {
  return (
    <div className={`${forceAllBreakpoints ? "" : "md:hidden"} p-3 grid grid-cols-1 gap-3`}>
      {data.map((p) => (
        <ProspectCardItem
          key={p.id}
          prospect={p}
          onEdit={onEdit}
          onDelete={onDelete}
          renderStatut={renderStatut}
        />
      ))}
    </div>
  );
}

function ProspectCardItem({ prospect: p, onEdit, onDelete, renderStatut }) {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((o) => !o);
  const detailsId = `prospect-details-${p.id}`;

  return (
    <div className="rounded-2xl p-4 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800">
      {/* Header minimal */}
      <div className="flex items-start gap-3">
        <div className="flex-1">
          <div className="font-semibold">{p.nom} {p.prenom}</div>
          <div className="text-sm text-slate-500">
            {p.association?.nom_asso || p.Association?.nom_asso || "—"} • {p.fonction || "—"}
          </div>
        </div>

        {/* Actions visibles de base : Éditer + Toggle */}
        <div className="flex items-center gap-2">
          <ButtonEdit onClick={() => onEdit?.(p)} />
          <button
            type="button"
            onClick={toggle}
            aria-expanded={open}
            aria-controls={detailsId}
            className="px-2.5 py-1.5 text-xs rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800"
            title={open ? "Replier" : "Dérouler"}
          >
            {open ? "▲" : "▼"}
          </button>
        </div>
      </div>

      {/* Zone déroulée */}
      <div
        id={detailsId}
        className={`transition-all duration-200 ease-out ${open ? "mt-3 max-h-[1000px]" : "max-h-0"} overflow-hidden`}
      >
        <div className="rounded-xl border border-slate-200 dark:border-slate-800 p-3 bg-slate-50 dark:bg-slate-800/60">
          {/* Statut inline (coloré) */}
          <div className="mb-2">
            {renderStatut?.(p)}
          </div>

          {/* Infos détaillées */}
          <div className="grid grid-cols-2 gap-2 text-sm">
            <Info label="Téléphone" value={p.telephone || "—"} />
            <Info label="Email" value={p.email || "—"} />
            <Info label="Provenance" value={p.provenance || "—"} />
            <Info label="Intérêt" value={p.interet_produit?.nom_app || "—"} />
            <Info
              label="Contact"
              value={p.date_contact ? new Date(p.date_contact).toLocaleDateString("fr-FR") : "—"}
              className="col-span-2"
            />
          </div>

          {/* Actions secondaires (moins critiques) */}
          <div className="mt-3">
            <ButtonDelete onClick={() => onDelete?.(p.id)} />
          </div>
        </div>
      </div>
    </div>
  );
}

function Info({ label, value, className = "" }) {
  return (
    <div className={`rounded-lg bg-white dark:bg-slate-900/60 p-2 border border-slate-200 dark:border-slate-800 ${className}`}>
      <div className="text-xs text-slate-500">{label}</div>
      <div className="font-medium">{value}</div>
    </div>
  );
}
